<div class="experience-form-card" [formGroup]="formGroup">

  <section class="block-section">
    <usb-request-header
      [formGroup]="formGroup"
      [selectedFile]="selectedFile"
      [selectedClient]="selectedClient"
      [availablePax]="availablePax"
      [loadingFiles]="loadingFiles"
      [loadingPax]="loadingPax"
      [loadingCountries]="loadingCountries"
      [showNewFileNameInput]="showNewFileNameInput"
      [showNewClientInput]="showNewClientInput"
      [existingFiles]="existingFiles"
      [countriesData]="countriesData"
      [newFilePassenger]="newFilePassenger"
      [newFilePassengerError]="newFilePassengerError"
      [newFilePhoneCode]="newFilePhoneCode"
      [newFilePhoneCodeError]="newFilePhoneCodeError"
      [newFilePhone]="newFilePhone"
      [newFilePhoneError]="newFilePhoneError"
      [newFileEmail]="newFileEmail"
      [newFileEmailError]="newFileEmailError"
      [phoneCodeSelected]="phoneCodeSelected"
      [selectedFileId]="selectedFileId"
      [selectedClientId]="selectedClientId"
      [edit]="edit"
      [requiredFieldMessage]="requiredFieldMessage"
      [getFileLabel]="getFileLabel"
      [getClientLabel]="getClientLabel"
      [getClientsForSelectedFile]="getClientsForSelectedFile"
      [isNuevoFileValid]="isNuevoFileValid"
      [blockInvalidKeys]="blockInvalidKeys"
      (fileChange)="fileChange.emit($event)"
      (fileSearchInput)="fileSearchInput.emit($event)"
      (clearSelectedFile)="clearSelectedFile.emit()"
      (clientChange)="clientChange.emit($event)"
      (paxChange)="paxChange.emit($event)"
      (passengerIdChange)="passengerIdChange.emit($event)"
      (passengerFirstNameChange)="passengerFirstNameChange.emit($event)"
      (passengerLastNameChange)="passengerLastNameChange.emit($event)"
      (requestTypeChange)="requestTypeChange.emit($event)"
      (newFileToggle)="newFileToggle.emit()"
      (newClientToggle)="newClientToggle.emit()"
      (newFileSubmit)="newFileSubmit.emit()"
      (newClientSubmit)="newClientSubmit.emit($event)"
      (newFilePassengerInput)="newFilePassengerInput.emit($event)"
      (newFilePhoneCodeInput)="newFilePhoneCodeInput.emit($event)"
      (newFileCountrySelected)="newFileCountrySelected.emit($event)"
      (newFilePhoneInput)="newFilePhoneInput.emit($event)"
      (newFileEmailInput)="newFileEmailInput.emit($event)"
      (countrySelected)="countrySelected.emit($event)"
      (phoneCodeInput)="phoneCodeInput.emit($event)"
      (clientFirstNameChange)="clientFirstNameChange.emit($event)"
      (clientLastNameChange)="clientLastNameChange.emit($event)"
      (clientEmailChange)="clientEmailChange.emit($event)"
      (clientPhoneChange)="clientPhoneChange.emit($event)"
    ></usb-request-header>
  </section>

  <section class="block-section">
    <header class="block-header">
      <span class="block-number">2</span>
      <div class="block-header-text">
        <p class="block-title">Destino, fechas y pasajeros</p>
        <p class="block-caption">Completá la información principal de la experiencia que estás cotizando.</p>
      </div>
    </header>

    <div class="form-grid-4">
      <div class="col-span-2">
        <label class="field-label">Destino <span class="required-marker">*</span></label>
        <div class="field-input-with-icon">
          <span class="field-icon">
            <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M20 10c0 6-8 12-8 12s-8-6-8-12a8 8 0 0 1 16 0Z"/><circle cx="12" cy="10" r="3"/></svg>
          </span>
          <input
            type="text"
            class="field-input"
            placeholder="Ciudad, país o región"
            formControlName="destination"
            list="experience-destinations"
            autocomplete="off"
          />
        </div>
        <datalist id="experience-destinations">
          <option value="Buenos Aires, Argentina"></option>
          <option value="Madrid, España"></option>
          <option value="Miami, Estados Unidos"></option>
          <option value="Río de Janeiro, Brasil"></option>
          <option value="Roma, Italia"></option>
        </datalist>
      </div>

      <div>
        <label class="field-label">Check-in <span class="required-marker">*</span></label>
        <div class="field-input-with-icon">
          <span class="field-icon">
            <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><rect x="3" y="4" width="18" height="18" rx="2" ry="2"/><line x1="16" y1="2" x2="16" y2="6"/><line x1="8" y1="2" x2="8" y2="6"/><line x1="3" y1="10" x2="21" y2="10"/></svg>
          </span>
          <input
            type="text"
            class="field-input"
            placeholder="Seleccioná la fecha"
            formControlName="checkIn"
            readonly
          />
        </div>
      </div>

      <div>
        <label class="field-label">Check-out <span class="required-marker">*</span></label>
        <div class="field-input-with-icon">
          <span class="field-icon">
            <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><rect x="3" y="4" width="18" height="18" rx="2" ry="2"/><line x1="16" y1="2" x2="16" y2="6"/><line x1="8" y1="2" x2="8" y2="6"/><line x1="3" y1="10" x2="21" y2="10"/></svg>
          </span>
          <input
            type="text"
            class="field-input"
            placeholder="Seleccioná la fecha"
            formControlName="checkOut"
            readonly
          />
        </div>
        <p class="field-error" *ngIf="formGroup.hasError('dateRange') && formGroup.get('checkOut')?.touched">
          No puede ser anterior al check-in.
        </p>
      </div>
    </div>

    <div class="guest-picker">
      <div class="guest-picker__stepper">
        <div class="guest-picker__stepper-row">
          <div class="guest-picker__stepper-cell">
            <div>
              <span class="guest-picker__label">Adultos</span>
              <span class="guest-picker__caption">A partir de 18 años</span>
            </div>
            <div class="guest-picker__controls">
              <button type="button" class="guest-picker__btn" aria-label="Restar adultos"
                      [disabled]="(formGroup.get('adults')?.value || 0) <= 1"
                      (click)="decrement('adults')">−</button>
              <span class="guest-picker__value">{{ formGroup.get('adults')?.value }}</span>
              <button type="button" class="guest-picker__btn" aria-label="Sumar adultos"
                      [disabled]="(formGroup.get('adults')?.value || 0) >= 20"
                      (click)="increment('adults')">+</button>
            </div>
          </div>
          <div class="guest-picker__stepper-cell">
            <div>
              <span class="guest-picker__label">Niños</span>
              <span class="guest-picker__caption">De 0 a 17 años</span>
            </div>
            <div class="guest-picker__controls">
              <button type="button" class="guest-picker__btn" aria-label="Restar niños"
                      [disabled]="(formGroup.get('children')?.value || 0) <= 0"
                      (click)="decrement('children')">−</button>
              <span class="guest-picker__value">{{ formGroup.get('children')?.value }}</span>
              <button type="button" class="guest-picker__btn" aria-label="Sumar niños"
                      [disabled]="(formGroup.get('children')?.value || 0) >= 17"
                      (click)="increment('children')">+</button>
            </div>
          </div>
        </div>
      </div>

      <div *ngIf="(formGroup.get('children')?.value || 0) > 0" class="guest-picker__ages">
        <select
          *ngFor="let age of childAgesArray.controls; let i = index"
          class="guest-picker__age-select"
          [formGroup]="childAgesArray.controls[i]"
          (change)="onChildAgeChange(i, $any($event.target).value)"
        >
          <option value="">Edad niño {{ i + 1 }}</option>
          <option *ngFor="let a of ageOptions" [value]="a">{{ a }} {{ a === 1 ? 'año' : 'años' }}</option>
        </select>
        <div class="guest-picker__info">
          <span class="guest-picker__info-icon">i</span>
          <p>Agregá la edad de cada niño para mostrarte el precio correcto para tu grupo.</p>
        </div>
      </div>
    </div>

    <div class="form-grid-4 mt-3">
      <div>
        <label class="field-label">Total de pasajeros</label>
        <input class="field-input" type="text" [value]="totalPassengers" readonly />
      </div>
      <div>
        <label class="field-label">Presupuesto estimado</label>
        <input class="field-input" type="number" placeholder="0,00" formControlName="budget" />
      </div>
      <div class="col-span-2">
        <label class="field-label">Nacionalidad</label>
        <input class="field-input" type="text" placeholder="Buscá una nacionalidad"
               formControlName="nationality"
               list="experience-nationalities" />
        <datalist id="experience-nationalities">
          <option value="Argentina"></option>
          <option value="Brasil"></option>
          <option value="Chile"></option>
          <option value="Colombia"></option>
          <option value="España"></option>
          <option value="Estados Unidos"></option>
          <option value="México"></option>
          <option value="Uruguay"></option>
        </datalist>
      </div>
    </div>
  </section>

  <section class="block-section">
    <header class="block-header">
      <span class="block-number">3</span>
      <div class="block-header-text">
        <p class="block-title">Tipo de experiencia</p>
        <p class="block-caption">Seleccioná la categoría de la experiencia que necesitás cotizar.</p>
      </div>
    </header>
    <div class="experience-pill-switch" role="radiogroup" aria-label="Tipo de experiencia">
      <span
        class="experience-pill-switch__indicator"
        [ngStyle]="{ transform: 'translateX(' + activeOffsetX + 'px)', width: activeWidth + 'px' }"
      ></span>
      <button
        *ngFor="let t of experienceTypes"
        #pill
        type="button"
        role="radio"
        [attr.aria-checked]="activeType === t.key"
        [class.active]="activeType === t.key"
        class="experience-pill-switch__btn"
        (click)="selectType(t.key)"
      >
        <span class="experience-pill-switch__icon">
          <svg *ngIf="t.key === 'city'" xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.6" stroke-linecap="round" stroke-linejoin="round"><rect width="16" height="20" x="4" y="2" rx="2" ry="2"/><path d="M9 22v-4h6v4"/><path d="M8 6h.01"/><path d="M16 6h.01"/><path d="M12 6h.01"/><path d="M12 10h.01"/><path d="M12 14h.01"/><path d="M16 10h.01"/><path d="M16 14h.01"/><path d="M8 10h.01"/><path d="M8 14h.01"/></svg>
          <svg *ngIf="t.key === 'shows'" xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.6" stroke-linecap="round" stroke-linejoin="round"><path d="M9.937 15.5A2 2 0 0 0 8.5 14.063l-6.135-1.582a.5.5 0 0 1 0-.962L8.5 9.936A2 2 0 0 0 9.937 8.5l1.582-6.135a.5.5 0 0 1 .963 0L14.063 8.5A2 2 0 0 0 15.5 9.937l6.135 1.581a.5.5 0 0 1 0 .964L15.5 14.063a2 2 0 0 0-1.437 1.437l-1.582 6.135a.5.5 0 0 1-.963 0z"/><path d="M20 3v4"/><path d="M22 5h-4"/><path d="M4 17v2"/><path d="M5 18H3"/></svg>
          <svg *ngIf="t.key === 'guiada'" xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.6" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="10"/><polygon points="16.24 7.76 14.12 14.12 7.76 16.24 9.88 9.88 16.24 7.76"/></svg>
          <svg *ngIf="t.key === 'barco'" xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.6" stroke-linecap="round" stroke-linejoin="round"><path d="M2 21c.6.5 1.2 1 2.5 1 2.5 0 2.5-2 5-2 1.3 0 1.9.5 2.5 1s1.2 1 2.5 1c2.5 0 2.5-2 5-2 1.3 0 1.9.5 2.5 1"/><path d="M19.38 20A11.6 11.6 0 0 0 21 14l-9-4-9 4c0 2.9.94 5.34 2.81 7.76"/><path d="M19 13V7a2 2 0 0 0-2-2H7a2 2 0 0 0-2 2v6"/><path d="M12 10v4"/><path d="M12 2v3"/></svg>
          <svg *ngIf="t.key === 'excursion'" xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.6" stroke-linecap="round" stroke-linejoin="round"><path d="M20 10c0 6-8 12-8 12s-8-6-8-12a8 8 0 0 1 16 0Z"/><circle cx="12" cy="10" r="3"/></svg>
          <svg *ngIf="t.key === 'aventura'" xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.6" stroke-linecap="round" stroke-linejoin="round"><path d="M4 14a1 1 0 0 1-.78-1.63l9.9-10.2a.5.5 0 0 1 .86.46l-1.92 6.02A1 1 0 0 0 13 10h7a1 1 0 0 1 .78 1.63l-9.9 10.2a.5.5 0 0 1-.86-.46l1.92-6.02A1 1 0 0 0 11 14z"/></svg>
        </span>
        <span class="experience-pill-switch__label">{{ t.label }}</span>
      </button>
    </div>
  </section>

  <section class="block-section">
    <header class="block-header">
      <span class="block-number">4</span>
      <div class="block-header-text">
        <p class="block-title">Detalles de la experiencia</p>
        <p class="block-caption">Indicá las características y preferencias del servicio.</p>
      </div>
    </header>

    <p class="block-helper" *ngIf="!activeType">Seleccioná un tipo de experiencia para ver sus opciones.</p>

    <ng-container [ngSwitch]="activeType">
      <div *ngSwitchCase="'city'" class="detail-grid-2">
        <div class="detail-card">
          <div class="detail-card__header">
            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.1" stroke-linecap="round" stroke-linejoin="round"><path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"/><circle cx="12" cy="7" r="4"/></svg>
            <span>Modalidad</span>
          </div>
          <ul class="detail-card__options">
            <li *ngFor="let opt of modalityOptions">
              <label class="detail-card__option">
                <span>{{ opt }}</span>
                <span class="radio-square">
                  <input type="radio" name="modality" [value]="opt"
                         [checked]="getDetail().modality?.includes(opt)"
                         (change)="setDetail('modality', opt)" />
                </span>
              </label>
            </li>
          </ul>
        </div>
        <div class="detail-card">
          <div class="detail-card__header">
            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.1" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="10"/><polyline points="12 6 12 12 16 14"/></svg>
            <span>Duración</span>
          </div>
          <div class="form-grid-2 mt-3">
            <input class="field-input" type="number" placeholder="0" min="1"
                   [value]="getDetail().durationQty"
                   (input)="patchDetail('durationQty', $any($event.target).value)" />
            <select class="field-input" [value]="getDetail().durationUnit"
                    (change)="patchDetail('durationUnit', $any($event.target).value)">
              <option value="horas">Horas</option>
              <option value="dias">Días</option>
            </select>
          </div>
        </div>
        <div class="detail-card">
          <div class="detail-card__header">
            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.1" stroke-linecap="round" stroke-linejoin="round"><path d="M20 13c0 5-3.5 7.5-7.66 8.95a1 1 0 0 1-.67-.01C7.5 20.5 4 18 4 13V6a1 1 0 0 1 1-1c2 0 4.5-1.2 6.24-2.72a1.17 1.17 0 0 1 1.52 0C14.51 3.81 17 5 19 5a1 1 0 0 1 1 1z"/></svg>
            <span>Política de cancelación</span>
          </div>
          <ul class="detail-card__options">
            <li *ngFor="let opt of cancellationOptions">
              <label class="detail-card__option">
                <span>{{ opt }}</span>
                <span class="radio-square">
                  <input type="radio" name="cancellation" [value]="opt"
                         [checked]="getDetail().cancellation?.includes(opt)"
                         (change)="setDetail('cancellation', opt)" />
                </span>
              </label>
            </li>
          </ul>
        </div>
        <div class="detail-card">
          <div class="detail-card__header">
            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.1" stroke-linecap="round" stroke-linejoin="round"><path d="M3 2v7c0 1.1.9 2 2 2h4a2 2 0 0 0 2-2V2"/><path d="M7 2v20"/><path d="M21 15V2v0a5 5 0 0 0-5 5v6c0 1.1.9 2 2 2h3Zm0 0v7"/></svg>
            <span>Gastronomía</span>
          </div>
          <ul class="detail-card__options">
            <li *ngFor="let opt of foodOptions">
              <label class="detail-card__option">
                <span>{{ opt }}</span>
                <span class="radio-square">
                  <input type="radio" name="food" [value]="opt"
                         [checked]="getDetail().food?.includes(opt)"
                         (change)="setDetail('food', opt)" />
                </span>
              </label>
            </li>
          </ul>
        </div>
      </div>

      <div *ngSwitchCase="'shows'" class="detail-grid-3">
        <div class="detail-card">
          <div class="detail-card__header">
            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.1" stroke-linecap="round" stroke-linejoin="round"><path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"/><circle cx="12" cy="7" r="4"/></svg>
            <span>Modalidad</span>
          </div>
          <ul class="detail-card__options">
            <li *ngFor="let opt of modalityOptions">
              <label class="detail-card__option">
                <span>{{ opt }}</span>
                <span class="radio-square">
                  <input type="radio" name="modality" [value]="opt"
                         [checked]="getDetail().modality?.includes(opt)"
                         (change)="setDetail('modality', opt)" />
                </span>
              </label>
            </li>
          </ul>
        </div>
        <div class="detail-card">
          <div class="detail-card__header">
            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.1" stroke-linecap="round" stroke-linejoin="round"><rect width="7" height="7" x="3" y="3" rx="1"/><rect width="7" height="7" x="14" y="3" rx="1"/><rect width="7" height="7" x="14" y="14" rx="1"/><rect width="7" height="7" x="3" y="14" rx="1"/></svg>
            <span>Tipo de ubicación</span>
          </div>
          <input class="field-input mt-3" placeholder="Platea, campo, palco..."
                 [value]="getDetail().location"
                 (input)="patchDetail('location', $any($event.target).value)" />
        </div>
        <div class="detail-card">
          <div class="detail-card__header">
            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.1" stroke-linecap="round" stroke-linejoin="round"><path d="M9.937 15.5A2 2 0 0 0 8.5 14.063l-6.135-1.582a.5.5 0 0 1 0-.962L8.5 9.936A2 2 0 0 0 9.937 8.5l1.582-6.135a.5.5 0 0 1 .963 0L14.063 8.5A2 2 0 0 0 15.5 9.937l6.135 1.581a.5.5 0 0 1 0 .964L15.5 14.063a2 2 0 0 0-1.437 1.437l-1.582 6.135a.5.5 0 0 1-.963 0z"/></svg>
            <span>Categoría</span>
          </div>
          <ul class="detail-card__options">
            <li *ngFor="let opt of categoryOptions">
              <label class="detail-card__option">
                <span>{{ opt }}</span>
                <span class="radio-square">
                  <input type="radio" name="category" [value]="opt"
                         [checked]="getDetail().category?.includes(opt)"
                         (change)="setDetail('category', opt)" />
                </span>
              </label>
            </li>
          </ul>
        </div>
        <div class="detail-card">
          <div class="detail-card__header">
            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.1" stroke-linecap="round" stroke-linejoin="round"><path d="M20 13c0 5-3.5 7.5-7.66 8.95a1 1 0 0 1-.67-.01C7.5 20.5 4 18 4 13V6a1 1 0 0 1 1-1c2 0 4.5-1.2 6.24-2.72a1.17 1.17 0 0 1 1.52 0C14.51 3.81 17 5 19 5a1 1 0 0 1 1 1z"/></svg>
            <span>Política de cancelación</span>
          </div>
          <ul class="detail-card__options">
            <li *ngFor="let opt of cancellationOptions">
              <label class="detail-card__option">
                <span>{{ opt }}</span>
                <span class="radio-square">
                  <input type="radio" name="cancellation" [value]="opt"
                         [checked]="getDetail().cancellation?.includes(opt)"
                         (change)="setDetail('cancellation', opt)" />
                </span>
              </label>
            </li>
          </ul>
        </div>
        <div class="detail-card">
          <div class="detail-card__header">
            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.1" stroke-linecap="round" stroke-linejoin="round"><path d="M3 2v7c0 1.1.9 2 2 2h4a2 2 0 0 0 2-2V2"/><path d="M7 2v20"/><path d="M21 15V2v0a5 5 0 0 0-5 5v6c0 1.1.9 2 2 2h3Zm0 0v7"/></svg>
            <span>Gastronomía</span>
          </div>
          <ul class="detail-card__options">
            <li *ngFor="let opt of foodOptions">
              <label class="detail-card__option">
                <span>{{ opt }}</span>
                <span class="radio-square">
                  <input type="radio" name="food" [value]="opt"
                         [checked]="getDetail().food?.includes(opt)"
                         (change)="setDetail('food', opt)" />
                </span>
              </label>
            </li>
          </ul>
        </div>
      </div>

      <div *ngSwitchCase="'guiada'" class="detail-grid-2">
        <div class="detail-card">
          <div class="detail-card__header">
            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.1" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="10"/><polyline points="12 6 12 12 16 14"/></svg>
            <span>Duración</span>
          </div>
          <ul class="detail-card__options">
            <li *ngFor="let opt of halfFullOptions">
              <label class="detail-card__option">
                <span>{{ opt }}</span>
                <span class="radio-square">
                  <input type="radio" name="halfFull" [value]="opt"
                         [checked]="getDetail().halfFull?.includes(opt)"
                         (change)="setDetail('halfFull', opt)" />
                </span>
              </label>
            </li>
          </ul>
        </div>
        <div class="detail-card">
          <div class="detail-card__header">
            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.1" stroke-linecap="round" stroke-linejoin="round"><path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"/><circle cx="12" cy="7" r="4"/></svg>
            <span>Modalidad</span>
          </div>
          <ul class="detail-card__options">
            <li *ngFor="let opt of modalityOptions">
              <label class="detail-card__option">
                <span>{{ opt }}</span>
                <span class="radio-square">
                  <input type="radio" name="modality" [value]="opt"
                         [checked]="getDetail().modality?.includes(opt)"
                         (change)="setDetail('modality', opt)" />
                </span>
              </label>
            </li>
          </ul>
        </div>
        <div class="detail-card">
          <div class="detail-card__header">
            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.1" stroke-linecap="round" stroke-linejoin="round"><path d="M20 13c0 5-3.5 7.5-7.66 8.95a1 1 0 0 1-.67-.01C7.5 20.5 4 18 4 13V6a1 1 0 0 1 1-1c2 0 4.5-1.2 6.24-2.72a1.17 1.17 0 0 1 1.52 0C14.51 3.81 17 5 19 5a1 1 0 0 1 1 1z"/></svg>
            <span>Política de cancelación</span>
          </div>
          <ul class="detail-card__options">
            <li *ngFor="let opt of cancellationOptions">
              <label class="detail-card__option">
                <span>{{ opt }}</span>
                <span class="radio-square">
                  <input type="radio" name="cancellation" [value]="opt"
                         [checked]="getDetail().cancellation?.includes(opt)"
                         (change)="setDetail('cancellation', opt)" />
                </span>
              </label>
            </li>
          </ul>
        </div>
        <div class="detail-card">
          <div class="detail-card__header">
            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.1" stroke-linecap="round" stroke-linejoin="round"><path d="M3 2v7c0 1.1.9 2 2 2h4a2 2 0 0 0 2-2V2"/><path d="M7 2v20"/><path d="M21 15V2v0a5 5 0 0 0-5 5v6c0 1.1.9 2 2 2h3Zm0 0v7"/></svg>
            <span>Gastronomía</span>
          </div>
          <ul class="detail-card__options">
            <li *ngFor="let opt of foodOptions">
              <label class="detail-card__option">
                <span>{{ opt }}</span>
                <span class="radio-square">
                  <input type="radio" name="food" [value]="opt"
                         [checked]="getDetail().food?.includes(opt)"
                         (change)="setDetail('food', opt)" />
                </span>
              </label>
            </li>
          </ul>
        </div>
      </div>

      <div *ngSwitchCase="'barco'" class="detail-grid-2">
        <div class="detail-card">
          <div class="detail-card__header">
            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.1" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="10"/><polyline points="12 6 12 12 16 14"/></svg>
            <span>Duración</span>
          </div>
          <ul class="detail-card__options">
            <li *ngFor="let opt of halfFullOptions">
              <label class="detail-card__option">
                <span>{{ opt }}</span>
                <span class="radio-square">
                  <input type="radio" name="halfFull" [value]="opt"
                         [checked]="getDetail().halfFull?.includes(opt)"
                         (change)="setDetail('halfFull', opt)" />
                </span>
              </label>
            </li>
          </ul>
        </div>
        <div class="detail-card">
          <div class="detail-card__header">
            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.1" stroke-linecap="round" stroke-linejoin="round"><path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"/><circle cx="12" cy="7" r="4"/></svg>
            <span>Modalidad</span>
          </div>
          <ul class="detail-card__options">
            <li *ngFor="let opt of modalityOptions">
              <label class="detail-card__option">
                <span>{{ opt }}</span>
                <span class="radio-square">
                  <input type="radio" name="modality" [value]="opt"
                         [checked]="getDetail().modality?.includes(opt)"
                         (change)="setDetail('modality', opt)" />
                </span>
              </label>
            </li>
          </ul>
        </div>
        <div class="detail-card">
          <div class="detail-card__header">
            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.1" stroke-linecap="round" stroke-linejoin="round"><path d="M20 13c0 5-3.5 7.5-7.66 8.95a1 1 0 0 1-.67-.01C7.5 20.5 4 18 4 13V6a1 1 0 0 1 1-1c2 0 4.5-1.2 6.24-2.72a1.17 1.17 0 0 1 1.52 0C14.51 3.81 17 5 19 5a1 1 0 0 1 1 1z"/></svg>
            <span>Política de cancelación</span>
          </div>
          <ul class="detail-card__options">
            <li *ngFor="let opt of cancellationOptions">
              <label class="detail-card__option">
                <span>{{ opt }}</span>
                <span class="radio-square">
                  <input type="radio" name="cancellation" [value]="opt"
                         [checked]="getDetail().cancellation?.includes(opt)"
                         (change)="setDetail('cancellation', opt)" />
                </span>
              </label>
            </li>
          </ul>
        </div>
        <div class="detail-card">
          <div class="detail-card__header">
            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.1" stroke-linecap="round" stroke-linejoin="round"><path d="M3 2v7c0 1.1.9 2 2 2h4a2 2 0 0 0 2-2V2"/><path d="M7 2v20"/><path d="M21 15V2v0a5 5 0 0 0-5 5v6c0 1.1.9 2 2 2h3Zm0 0v7"/></svg>
            <span>Gastronomía</span>
          </div>
          <ul class="detail-card__options">
            <li *ngFor="let opt of foodOptions">
              <label class="detail-card__option">
                <span>{{ opt }}</span>
                <span class="radio-square">
                  <input type="radio" name="food" [value]="opt"
                         [checked]="getDetail().food?.includes(opt)"
                         (change)="setDetail('food', opt)" />
                </span>
              </label>
            </li>
          </ul>
        </div>
      </div>

      <div *ngSwitchCase="'excursion'" class="detail-grid-3">
        <div class="detail-card">
          <div class="detail-card__header">
            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.1" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="10"/><polyline points="12 6 12 12 16 14"/></svg>
            <span>Duración</span>
          </div>
          <ul class="detail-card__options">
            <li *ngFor="let opt of halfFullOptions">
              <label class="detail-card__option">
                <span>{{ opt }}</span>
                <span class="radio-square">
                  <input type="radio" name="halfFull" [value]="opt"
                         [checked]="getDetail().halfFull?.includes(opt)"
                         (change)="setDetail('halfFull', opt)" />
                </span>
              </label>
            </li>
          </ul>
        </div>
        <div class="detail-card">
          <div class="detail-card__header">
            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.1" stroke-linecap="round" stroke-linejoin="round"><path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"/><circle cx="12" cy="7" r="4"/></svg>
            <span>Modalidad</span>
          </div>
          <ul class="detail-card__options">
            <li *ngFor="let opt of modalityOptions">
              <label class="detail-card__option">
                <span>{{ opt }}</span>
                <span class="radio-square">
                  <input type="radio" name="modality" [value]="opt"
                         [checked]="getDetail().modality?.includes(opt)"
                         (change)="setDetail('modality', opt)" />
                </span>
              </label>
            </li>
          </ul>
        </div>
        <div class="detail-card">
          <div class="detail-card__header">
            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.1" stroke-linecap="round" stroke-linejoin="round"><path d="M20 10c0 6-8 12-8 12s-8-6-8-12a8 8 0 0 1 16 0Z"/><circle cx="12" cy="10" r="3"/></svg>
            <span>Tipo de excursión</span>
          </div>
          <input class="field-input mt-3" placeholder="Buscá o escribí el tipo"
                 [value]="getDetail().excursionType"
                 (input)="patchDetail('excursionType', $any($event.target).value)" />
        </div>
        <div class="detail-card">
          <div class="detail-card__header">
            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.1" stroke-linecap="round" stroke-linejoin="round"><path d="M20 13c0 5-3.5 7.5-7.66 8.95a1 1 0 0 1-.67-.01C7.5 20.5 4 18 4 13V6a1 1 0 0 1 1-1c2 0 4.5-1.2 6.24-2.72a1.17 1.17 0 0 1 1.52 0C14.51 3.81 17 5 19 5a1 1 0 0 1 1 1z"/></svg>
            <span>Política de cancelación</span>
          </div>
          <ul class="detail-card__options">
            <li *ngFor="let opt of cancellationOptions">
              <label class="detail-card__option">
                <span>{{ opt }}</span>
                <span class="radio-square">
                  <input type="radio" name="cancellation" [value]="opt"
                         [checked]="getDetail().cancellation?.includes(opt)"
                         (change)="setDetail('cancellation', opt)" />
                </span>
              </label>
            </li>
          </ul>
        </div>
        <div class="detail-card">
          <div class="detail-card__header">
            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.1" stroke-linecap="round" stroke-linejoin="round"><path d="M3 2v7c0 1.1.9 2 2 2h4a2 2 0 0 0 2-2V2"/><path d="M7 2v20"/><path d="M21 15V2v0a5 5 0 0 0-5 5v6c0 1.1.9 2 2 2h3Zm0 0v7"/></svg>
            <span>Gastronomía</span>
          </div>
          <ul class="detail-card__options">
            <li *ngFor="let opt of foodOptions">
              <label class="detail-card__option">
                <span>{{ opt }}</span>
                <span class="radio-square">
                  <input type="radio" name="food" [value]="opt"
                         [checked]="getDetail().food?.includes(opt)"
                         (change)="setDetail('food', opt)" />
                </span>
              </label>
            </li>
          </ul>
        </div>
      </div>

      <div *ngSwitchCase="'aventura'" class="detail-grid-2">
        <div class="detail-card">
          <div class="detail-card__header">
            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.1" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="10"/><polyline points="12 6 12 12 16 14"/></svg>
            <span>Duración</span>
          </div>
          <ul class="detail-card__options">
            <li *ngFor="let opt of halfFullOptions">
              <label class="detail-card__option">
                <span>{{ opt }}</span>
                <span class="radio-square">
                  <input type="radio" name="halfFull" [value]="opt"
                         [checked]="getDetail().halfFull?.includes(opt)"
                         (change)="setDetail('halfFull', opt)" />
                </span>
              </label>
            </li>
          </ul>
        </div>
        <div class="detail-card">
          <div class="detail-card__header">
            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.1" stroke-linecap="round" stroke-linejoin="round"><path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"/><circle cx="12" cy="7" r="4"/></svg>
            <span>Modalidad</span>
          </div>
          <ul class="detail-card__options">
            <li *ngFor="let opt of modalityOptions">
              <label class="detail-card__option">
                <span>{{ opt }}</span>
                <span class="radio-square">
                  <input type="radio" name="modality" [value]="opt"
                         [checked]="getDetail().modality?.includes(opt)"
                         (change)="setDetail('modality', opt)" />
                </span>
              </label>
            </li>
          </ul>
        </div>
        <div class="detail-card">
          <div class="detail-card__header">
            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.1" stroke-linecap="round" stroke-linejoin="round"><path d="M20 13c0 5-3.5 7.5-7.66 8.95a1 1 0 0 1-.67-.01C7.5 20.5 4 18 4 13V6a1 1 0 0 1 1-1c2 0 4.5-1.2 6.24-2.72a1.17 1.17 0 0 1 1.52 0C14.51 3.81 17 5 19 5a1 1 0 0 1 1 1z"/></svg>
            <span>Política de cancelación</span>
          </div>
          <ul class="detail-card__options">
            <li *ngFor="let opt of cancellationOptions">
              <label class="detail-card__option">
                <span>{{ opt }}</span>
                <span class="radio-square">
                  <input type="radio" name="cancellation" [value]="opt"
                         [checked]="getDetail().cancellation?.includes(opt)"
                         (change)="setDetail('cancellation', opt)" />
                </span>
              </label>
            </li>
          </ul>
        </div>
        <div class="detail-card">
          <div class="detail-card__header">
            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.1" stroke-linecap="round" stroke-linejoin="round"><path d="M3 2v7c0 1.1.9 2 2 2h4a2 2 0 0 0 2-2V2"/><path d="M7 2v20"/><path d="M21 15V2v0a5 5 0 0 0-5 5v6c0 1.1.9 2 2 2h3Zm0 0v7"/></svg>
            <span>Gastronomía</span>
          </div>
          <ul class="detail-card__options">
            <li *ngFor="let opt of foodOptions">
              <label class="detail-card__option">
                <span>{{ opt }}</span>
                <span class="radio-square">
                  <input type="radio" name="food" [value]="opt"
                         [checked]="getDetail().food?.includes(opt)"
                         (change)="setDetail('food', opt)" />
                </span>
              </label>
            </li>
          </ul>
        </div>
      </div>
    </ng-container>
  </section>

  <section class="block-section">
    <header class="block-header">
      <span class="block-number">5</span>
      <div class="block-header-text">
        <p class="block-title">Expandir tu búsqueda</p>
        <p class="block-caption">Opciones adicionales para mejorar los resultados.</p>
      </div>
    </header>
    <button type="button" class="btn-expand-search" (click)="toggleExpanded()">
      <span class="btn-expand-search__icon">{{ formGroup.get('expanded')?.value ? '×' : '+' }}</span>
      <span>Expandir tu búsqueda</span>
    </button>
    <div *ngIf="formGroup.get('expanded')?.value" class="mt-3">
      <textarea class="field-input" rows="4"
                placeholder="Agregá ubicaciones de referencia, nombres de experiencias, prestadores o cualquier información que ayude a ampliar la búsqueda."
                formControlName="searchNotes"></textarea>
    </div>
  </section>

  <section class="block-section">
    <header class="block-header">
      <span class="block-number">6</span>
      <div class="block-header-text">
        <p class="block-title">Comentarios u observaciones</p>
        <p class="block-caption">Agregá información adicional para tu equipo.</p>
      </div>
    </header>
    <textarea class="field-input" rows="5"
              placeholder="Escribí cualquier información adicional que debamos tener en cuenta."
              formControlName="comments" maxlength="1000"></textarea>
  </section>

  <div class="form-footer">
    <p class="form-footer__caption">Podés incluir diferentes servicios dentro de una misma solicitud.</p>
    <div class="form-footer__actions">
      <button type="button" class="btn-clear" (click)="confirmClear()">Borrar</button>
      <button type="button" class="btn-submit"
              [disabled]="!requestReady || formGroup.invalid"
              (click)="onSubmit()">Enviar</button>
    </div>
  </div>

  <div *ngIf="showClearDialog" class="confirm-overlay">
    <div class="confirm-dialog">
      <h4>¿Querés borrar los datos cargados en esta cotización?</h4>
      <div class="confirm-dialog__actions">
        <button type="button" class="btn-cancel" (click)="cancelClear()">Cancelar</button>
        <button type="button" class="btn-danger" (click)="confirmClearAction()">Sí, borrar</button>
      </div>
    </div>
  </div>

</div>
